import { render } from "./CollectionsManager.vue?vue&type=template&id=33acc4d1"
import script from "./CollectionsManager.vue?vue&type=script&lang=js"
export * from "./CollectionsManager.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__